// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavItemDropdown_wrapper__UcZZB","dropdown":"NavItemDropdown_dropdown__14hFX"};